<!--ptw总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 60px; line-height: 70px; padding-left: 20px; text-align: left">
      <div class="enp-select"
           style="position: absolute; z-index: 9;width: 100%;">
        <el-select v-model="default_enp"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_enp">
          <el-option
            v-for="item in ep_list"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </h1>
    <div v-if="dataNotNull" key="1" class="enp1div"
         style="width: 100%; height: 100%; position: absolute; bottom: 0">
      <div class="select"
           style="position: absolute; right: 5%; z-index: 9;width: 13%;">
        <el-select v-model="default_tag"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_tag">
          <el-option
            v-for="item in multi_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="container1" style="height: 100%;margin-top: 5%"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;"
         class="enp1div">
      No Data !
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id', 'current_gate', 'gate_list'],
  name: "proj_ptw",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "epstatics",
      dataNotNull: true,
      default_tag: "Daily",
      multi_tags: [
        {label: "Monthly", value: "1"},
        {label: "Daily", value: "0"},
        // {label: "Acc.", value: "3"},
        // {label: "Last Month", value: "4"},
      ],
      default_enp: "",
      default_enp_id: "",
      ep_list: [],
    }
  },

  methods: {
    init() {
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    formatWidth(str, width) {
      str += ''
      if (str.length < width)
        return this.formatWidth('0' + str, width)
      else
        return str
    },
    switch_tag(label) {
      this.sum = 0
      this.getData(label, this.default_enp_id)
    },

    switch_enp(label) {
      this.sum = 0
      this.getData('0', label)
    },
    getData(period, epid) {
      var that = this
      let postData = {
        proj_id: this.project_id,
        bes_project_id: window.localStorage.getItem('bes_project_id'),
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        epid: epid,
        period: period
      }
      axios.post(this.$store.getters.getHCSServer + "EPStatics", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          that.$nextTick().then(() => {
            that.init_chart()
            that.myChart.hideLoading()
            var result = resp.data.result;
            var data = this.analysisResult(result)
            this.myChart.setOption({
              yAxis: {
                data: data.legends
              },
              series: [
                {
                  data: data.totle
                },
                {
                  data: data.assists,
                  label: {
                    normal: {
                      show: true,
                      color: '#6cf',
                      position: 'right',
                      formatter: function (params) {
                        return parseInt(params.value) - parseInt(data.assist);
                      }
                    }
                  },
                },
                {
                  data: data.encs
                }
              ]
            })
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
    analysisResult(result) {
      var encs = []
      var assists = []
      var totle = []
      var total = 0
      var assist = 0
      var legends = []

      for (var i in result) {
        let name = ''
        if (result[i].org_name != null && result[i].org_name != '') {
          name = result[i].org_name
        } else {
          name = 'visitor'
        }
        if (name.length > 22) {
          name = name.substring(0, 22) + '\n' + name.substring(22, name.length)
        }
        legends.push(name)
        encs.push({name: name, value: result[i].count})
        total += parseInt(result[i].count)
      }
      var cover = total * 0.7
      var covers = []
      total *= 0.7
      assist = total / 5
      // assist = 0
      for (var i in encs) {
        var name = encs[i].name
        var value = parseInt(encs[i].value) + assist
        assists.push({name: name, value: value})
        totle.push({name: name, value: total})
        covers.push({name: name, value: cover})
      }
      return {encs: encs, assists: assists, totle: totle, assist: assist, covers: covers, legends: legends}
    },
    init_chart() {
      let that = this
      this.myChart = echarts.init(document.querySelector('.enp1div .container1'))
      this.myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (params) {
            return params[1].name + ':  ' + Math.round(params[2].value * 70 / params[0].value) + '%';
            // return params[1].name + ':  ' + params[2].value + params[0].value
          },
          textStyle: {
            fontSize: '40'
          }
        },
        grid: {
          left: 330
        },
        xAxis: {
          type: 'value',
          show: false,
          axisLabel: {
            formatter: '{value}'
          }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6CF'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 300,
            show: true,
            textStyle: {
              color: '#FFF',
              fontSize: 22,
              align: 'left',
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '总计',
            type: 'bar',
            barGap: '-100%',
            barWidth: '60%',
            label: {
              normal: {
                show: false,
                color: '#6cf',
                position: 'Right',
              }
            },
            itemStyle: {
              normal: {
                color: '#00000000',
                borderColor: '#999',
                borderWidth: '0',
              }
            },
            data: []
          },
          {
            name: '总计',
            type: 'bar',
            barGap: '-100%',
            barWidth: '60%',
            label: {
              normal: {
                show: true,
                color: '#6cf',
                position: 'right',
                formatter: '{c}',
                textStyle: {
                  fontSize: 42
                }
              }
            },
            itemStyle: {
              normal: {
                color: '#00000000',
              }
            },
            data: []
          },
          {
            name: '申请',
            type: 'bar',
            barWidth: '60%',
            data: [],
            label: {
              normal: {
                show: false,
                formatter: '{b}'
              }
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return that.color[params.dataIndex]
                },
              }
            },
          }
        ]
      })
      this.myChart.showLoading({
        text: '',
        color: '#66CCFF',
        maskColor: 'rgba(255, 255, 255, 0)',
      });
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    this.default_enp_id = this.current_gate.value
    this.default_enp = this.current_gate.label
    this.init_chart()
  },
  watch: {
    gate_list: {
      immediate: true,
      handler(newVal, oldVal) {
        this.ep_list = newVal
      }
    },
    current_gate: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        this.default_enp = newVal.label
        this.default_enp_id = newVal.value
        this.getData("0", this.default_enp_id)
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/HCS/entry1count.vue